import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Starter Website',
  price: "$600",
  suffix: '/starting',
  desc: 'Perfect for small businesses needing a professional online presence quickly.',
  features: ['Custom Design (No Templates)', 'Mobile Responsive', 'Contact Form Integration', '3 Round of Revisions'],
  highlighted: false
}, {
  name: 'Hosting',
  price: "$0 Limited Time",
  suffix: "",
  desc: 'The hosting fee covers the services and infrastructure required to keep it live, secure, and accessible on the internet.',
  features: ['Includes 5 Edits per Year', 'Premium Cloud Hosting', 'SSL Security Certificate', 'Daily Backups', 'Always Online & Accessible'],
  highlighted: true
}];
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#0A0A0F] relative" data-id="element-275" data-mp="3h74pkw9qcbf5">
      <div className="container mx-auto px-6 md:px-12" data-id="element-276" data-mp="3h9haniasb1wf">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-277" data-mp="3c78jmrhh29wy">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-278" data-mp="3vzp6pldb6gal">
            Simple, <span className="text-gradient" data-id="element-279" data-mp="4t5kzb5xp5xi">Upfront Pricing</span>
          </h2>
          <p className="text-lg mb-4 text-[#FFFFFF]" data-id="element-280" data-mp="4v8j6ih8q5db">
            High-quality web design shouldn't be a mystery. Choose the package
            that fits your goals.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto items-stretch" data-id="element-281" data-mp="ep8xnayewmyp">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative rounded-3xl p-8 flex flex-col ${tier.highlighted ? 'bg-[#161622] border-2 border-blue-500 shadow-[0_0_30px_rgba(59,130,246,0.15)]' : 'bg-[#111118] border border-white/5'}`} data-id="element-282" data-mp="3i7si3raumoiy" data-mpi={index}>
              <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-283" data-mp="2zfg8cjhv8kys">
                {tier.name}
              </h3>
              <p className="text-sm mb-6 text-[#FFFFFF]" data-id="element-284" data-mp="2mi1jndv0nr9v">{tier.desc}</p>

              <div className="mb-8" data-id="element-285" data-mp="2mfxkf982bgfx">
                <span className="text-4xl font-bold text-white" data-id="element-286" data-mp="3177ll9l8nvlg">
                  {tier.price}
                </span>
                <span className="text-[#FFFFFF]" data-id="element-287" data-mp="2w8mkz922r9wh">{tier.suffix}</span>
              </div>

              <a href="#contact" className={`block w-full py-3 px-6 rounded-lg text-center font-medium transition-all mb-8 ${tier.highlighted ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:shadow-[0_0_20px_rgba(59,130,246,0.3)]' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-288" data-mp="28h7ed439m6ff">
                Get Started
              </a>

              <div className="space-y-4 mt-auto" data-id="element-289" data-mp="3tvbqvtzwe6nm">
                {tier.features.map((feature, fIndex) => <div key={fIndex} className="flex items-start gap-3" data-id="element-290" data-mp="3tx6exh6guevx" data-mpi={fIndex}>
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500/10 flex items-center justify-center mt-0.5" data-id="element-291" data-mp="3ovqunrc44cel">
                      <Check size={12} className="text-blue-400" data-id="element-292" data-mp="cq8dj3osw3g" />
                    </div>
                    <span className="text-sm text-[#FFFFFF]" data-id="element-293" data-mp="573zvaf8aj2u">{feature}</span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}